/* eslint-disable react-refresh/only-export-components --
 * Context module: Provider + hook are intentionally co-located.
 */
import React, { createContext, useContext, useMemo } from 'react';

interface ClinicContextValue {
  /** Clinic the visit belongs to, or null when the form renders without one. */
  agencyClinicId: string | null;
}

const ClinicContext = createContext<ClinicContextValue>({
  agencyClinicId: null,
});

/**
 * Clinic the surrounding visit belongs to, for form fields that need a roster
 * scoped to it (the attending physician picker).
 *
 * Deliberately does NOT throw when no provider is mounted: the bespoke layout
 * coverage checker renders sections offscreen with no visit, and those must
 * fall back to a plain input rather than error or fetch.
 */
export function useClinicContext(): ClinicContextValue {
  return useContext(ClinicContext);
}

export function ClinicProvider({
  agencyClinicId,
  children,
}: {
  agencyClinicId: string | null;
  children: React.ReactNode;
}) {
  // Memoized so consumers do not re-render on every keystroke in the form.
  const value = useMemo(() => ({ agencyClinicId }), [agencyClinicId]);
  return (
    <ClinicContext.Provider value={value}>{children}</ClinicContext.Provider>
  );
}
